// src/pages/Appointments/AppointmentDetails.js
import React from 'react';
import { useApp } from '../../context/AppContext';
import { ArrowLeftIcon, MapPinIcon, PhoneIcon } from '../../components/common/Icons';
import { Button } from '../../components/common/Button';

const AppointmentDetails = () => {
  const { navigateTo, selectedAppointment } = useApp();
  
  // Creăm o programare implicită pentru a evita erorile de undefined
  const defaultAppointment = {
    id: 1,
    status: 'FINALIZAT',
    date: 'Sâ. 15 feb.',
    time: '14:45',
    repeating: false,
    service: 'Tuns',
    price: '60 lei',
    salon: 'Frizerie cu Stil și Coafor Focsani',
    specialist: 'Eugen Ciprian Grigore',
    duration: '45 min',
    location: {
      address: 'Bulevardul Brăilei nr 102 (Parcare Kaufland), Focșani',
      phone: '0765 407 582',
      coordinates: {
        lat: 45.6965,
        lng: 27.1862
      }
    }
  };
  
  // Folosim selectedAppointment dacă există, altfel folosim defaultAppointment
  const appointment = selectedAppointment || defaultAppointment;
  
  // Extragem location și oferim un fallback dacă nu există
  const location = appointment.location || {
    address: 'Adresă indisponibilă',
    phone: 'Telefon indisponibil',
    coordinates: { lat: 0, lng: 0 }
  };

  return (
    <div className="flex flex-col h-full bg-gray-50">
      <header className="bg-white p-4 flex items-center justify-between border-b">
        <div className="flex items-center">
          <button 
            className="mr-3"
            onClick={() => navigateTo('appointments')}
          >
            <ArrowLeftIcon size={24} />
          </button>
          <h1 className="text-xl font-medium">Detalii programare</h1>
        </div>
        <button className="text-blue-600 font-medium">
          Opțiuni
        </button>
      </header>
      
      <div className="flex-1 overflow-y-auto">
        <div className="bg-white p-6 mb-4">
          <div className="mb-2 text-blue-600 font-medium">
            {appointment.status}
          </div>
          
          <h2 className="text-2xl font-bold mb-1">
            {appointment.date} - {appointment.time}
          </h2>
          
          <p className="text-gray-700">
            {appointment.repeating ? 'Se repetă' : 'Nu se repetă'}
          </p>
        </div>
        
        <div className="bg-white p-6 mb-4 flex items-center border-t border-b">
          <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center mr-4">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
              <path d="M8 12L11 15L16 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          
          <div className="flex-1">
            <h3 className="text-xl font-medium">{appointment.service}</h3>
            <p className="text-gray-700">{appointment.specialist} - {appointment.salon}</p>
            <p className="text-gray-600 mt-1">{appointment.duration}</p>
          </div>
          
          <div className="text-xl font-bold">
            {appointment.price}
          </div>
        </div>
        
        <div className="mt-4">
          <h3 className="text-2xl font-bold px-4 mb-2">
            {appointment.salon}
          </h3>
          
          <a 
            href={`tel:${location.phone}`} 
            className="flex items-center px-4 py-6 border-b bg-white"
          >
            <PhoneIcon size={24} className="text-gray-600 mr-4" />
            <span className="text-xl font-medium">{location.phone}</span>
          </a>
          
          <div className="flex items-center px-4 py-6 border-b bg-white">
            <MapPinIcon size={24} className="text-gray-600 mr-4" />
            <span className="text-lg">{location.address}</span>
          </div>
          
          <div className="px-4 pt-4 pb-8 bg-white">
            <div className="w-full h-56 bg-gray-200 rounded mb-4">
              {/* Aici ar trebui integrată o hartă reală */}
              <div className="w-full h-full flex items-center justify-center">
                <img 
                  src="/api/placeholder/600/300" 
                  alt="Hartă" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            
            <button className="w-full py-4 bg-blue-100 text-blue-600 rounded-full font-medium">
              Vezi direcții de navigare
            </button>
          </div>
        </div>
      </div>
      
      <div className="p-4 border-t bg-white">
        <Button
          variant="primary"
          fullWidth
          size="lg"
          rounded="full"
          onClick={() => navigateTo('selectDate', { 
            salon: { name: appointment.salon },
            specialist: { name: appointment.specialist },
            service: { name: appointment.service, price: appointment.price }
          })}
        >
          Programează din nou
        </Button>
      </div>
    </div>
  );
};

export default AppointmentDetails;